import React from 'react';
import { Link } from 'react-router-dom';

import { ContainerCR } from './style.js';
import Container from 'react-bootstrap/Container';

import dmLogo from '../../imgs/logos/dm.png';

const Footer = () => {
  return (
    <>
      <ContainerCR>
        <Container>
          <Link to="https://datamais.com.br" target="_blank">
            <img src={dmLogo} alt="" />
          </Link>
        </Container>
      </ContainerCR>
    </>
  );
};

export default Footer;
